import React, { useContext, useEffect, useState } from "react";
import EditableTableTasks from "./EditableTableTasks";
import { IndividualWorkPlanContext } from "../../../../utils/context";


export default function TaskForYear(
  { }
) {

  const { taskForYear } = useContext(IndividualWorkPlanContext)
  const [dataForTable, setDataForTable] = useState([])

  useEffect(() => {
    !!taskForYear && setDataForTable(taskForYear)
  }, [taskForYear])

  const handleAddTask = () => {
    setDataForTable(prev => [...prev, {
      "task": "",
      "term": "",
      "performed": 0,
      "mode": null,
    }])
  }
  return (
    <div>
      <div className="table" style={{ marginTop: "1rem", paddingTop: 0 }}>
        {/* {data && data.cathedras.length ? */}
        <table className="tg-second">
          <tr style={{ position: "sticky", top: "0" }}>
            <th className="tg-s6z2">№ п.п</th>
            <th className="tg-yw4l">Задачи по видам деятельности</th>
            <th className="tg-yw4l">Срок выполнения</th>
            <th className="tg-yw4l">Отметка о выполнении</th>
            {/* <th className="tg-yw4l">Удалить</th> */}
          </tr>

          {dataForTable && dataForTable.map((item, i) =>
            <EditableTableTasks item={item} i={i} />
          )}
        </table>
      </div>
      {/* <div className="div__buttons">
        <div className="buttons__change" onClick={handleAddTask} setDataForTable={setDataForTable}>Добавить</div>
        <div className="buttons__leave">Удалить</div>
      </div> */}
    </div>
  );
}
